import type { VerbName } from "./types";

export const ALL_VERBS = [
	"NAVIGATE",
	"BACK",
	"TOGGLE_RADIO",
	"CHANGE_STATION",
	"PLAY_SOUND",
	"SET_VOLUME",
	"CHANGE_SCENE_STATE",
] as const;
export const VERBS = {
	NAVIGATE: "NAVIGATE",
	BACK: "BACK",
	TOGGLE_RADIO: "TOGGLE_RADIO",
	CHANGE_STATION: "CHANGE_STATION",
	PLAY_SOUND: "PLAY_SOUND",
	SET_VOLUME: "SET_VOLUME",
	CHANGE_SCENE_STATE: "CHANGE_SCENE_STATE",
} as const satisfies Record<VerbName, VerbName>;
